__turbopack_context__.v({
  "detailsCard": "qpNf8q_detailsCard",
  "detailsItem": "qpNf8q_detailsItem",
  "detailsItemLabel": "qpNf8q_detailsItemLabel",
  "smallText": "qpNf8q_smallText",
  "smallTextBold": "qpNf8q_smallTextBold",
  "smallTextWrapper": "qpNf8q_smallTextWrapper",
});
